export enum EStatusSeance {
	pending = 1,
	done,
	canceled,
	inProgress,
	completed,
	to_be_done,
	paused
}